import React from "react";
import { AssetLocation, AssetType } from "../../../../../logic/api";
import { useDate } from "../../../../../utility/useDate";
import { locationDescription } from "../condensedLayoutUtils";
import styles from "../styles";
import { useTranslation } from "react-i18next";

const AuditsDueRow: React.FunctionComponent<{
    assetLocation: AssetLocation,
    auditCategory: number,
    rowIndex: number,
    onClick: () => void
}> = (props) => {
    const { toFormattedFullDateTimeString } = useDate();

    const { assetLocation, auditCategory, rowIndex } = props;
    const { t } = useTranslation();

    const getAuditDueDate = () => {
        if (auditCategory === AssetType.vehicle) {
            return assetLocation.auditDueDate;
        }

        if (auditCategory === AssetType.vehicleKey) {
            return assetLocation.keyAuditDueDate;
        }
    }

    return (<tr style={rowIndex % 2 ? styles.tableRowOdd : styles.tableRowEven} onClick={props.onClick}>
        <td style={styles.tableCell}>{t("locations.due")}</td>
        <td style={styles.tableCell}>{toFormattedFullDateTimeString(getAuditDueDate())}</td>
        <td style={styles.tableCell}>{locationDescription(assetLocation)}</td>
    </tr>)
}

export default AuditsDueRow;
